'use strict';

import './layout.css';

var layoutMdl = angular.module('layoutMdl', []);

import menu from 'compartilhado/plugins/menu.plugin'

layoutMdl.config(layoutConfig).use(menu);

layoutConfig.$inject = ['$stateProvider', '$datepickerProvider'];
function layoutConfig($stateProvider, $datepickerProvider) {
    $stateProvider
    .state('app', {
        abstract: true,
        template: require('./layout-template.html'),
        controller: 'layoutCtrl'
    });

    angular.extend($datepickerProvider.defaults, {
        dateFormat: 'dd/MM/yyyy',
        startWeek: 1
    });
}



// WEBPACK FOOTER //
// ./src/modules/layout/layout-config.js